import React, { useEffect, useState } from "react";

export default function Ticker() {
  const [videoInfo, setVideoInfo] = useState({
    title: "",
    channel: "",
  });

  const apiKey = "AIzaSyBhPk034uz-x_E5vewJDGAD35cYN-kE4FI";
  const videoId = "eKO9BGdQ7Wk";

  useEffect(() => {
    fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apiKey}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.items?.length > 0) {
          const s = data.items[0].snippet;
          setVideoInfo({
            title: s.title,
            channel: s.channelTitle,
          });
        }
      });
  }, []);

  return (
    <div style={styles.tickerWrap}>
            <div className="ticker" style={{ display: 'flex', whiteSpace: 'nowrap',  letterSpacing: '.3px', fontFamily: '"Inter", sans-serif' }}>
              {[...Array(10)].map((_, i) => (
                <span key={i} style={{ paddingRight: '2px', color: '#000' }}>
                Tap anywhere to play, double tap to stop: "{videoInfo.title}" .˚₊♬⋆.˚♪˚.⋆♬₊˚. by: {videoInfo.channel} (YouTube) ✦
                </span>
              ))}
            </div>

      <style>{`
            .ticker {
              animation: tickerMove 130s linear infinite;
            }
            .ticker:hover {
              animation-play-state: paused;
            }
            @keyframes tickerMove {
              0% { transform: translateX(0) scaleY(0.95); }
              100% { transform: translateX(-50%) scaleY(0.95); }
            }
      `}</style>
    </div>
  );
}

const styles = {
  tickerWrap: {
    width: '100%',
    backgroundColor: '#E9D6D2',
    position: 'fixed',
    bottom: 0,
    height: '50px',
    display: 'flex',
    alignItems: 'center',
  },
};